import { defineMessages } from 'react-intl';

export const wizardInsuranceFooterMessages = defineMessages({
  insureThisShipment: {
    defaultMessage: 'Insure this shipment',
    id: 'fHqxhC',
    description: 'Label for the insurance toggle in the rates panel footer',
  },
  upsCapitalTerms: {
    defaultMessage: 'See UPS Capital Terms & Conditions',
    id: 'VzyX9W',
    description: 'Link to UPS Capital insurance terms and conditions in the rates panel footer',
  },
  edit: {
    defaultMessage: 'Edit',
    id: 'vUVzGg',
    description: 'Button to open the insurance edit form in the rates panel footer',
  },
  done: {
    defaultMessage: 'Done',
    id: '6x/Usb',
    description: 'Button to collapse the insurance edit form back to summary',
  },
  summaryConditionLabel: {
    defaultMessage: 'Condition',
    id: 'zCEiHm',
    description: 'Column label for condition in the insurance summary row',
  },
  summaryCategoryLabel: {
    defaultMessage: 'Category',
    id: '4MVJvB',
    description: 'Column label for category in the insurance summary row',
  },
  summaryInsuredValueLabel: {
    defaultMessage: 'Insured Value',
    id: 'AmsSrG',
    description: 'Column label for insured value in the insurance summary row',
  },
  summaryMarksLabel: {
    defaultMessage: 'Marks & Num.',
    id: '0YRZSb',
    description: 'Abbreviated column label for marks and numbers in the insurance summary row',
  },
  marksAndNumbersPlaceholder: {
    defaultMessage: 'Enter',
    id: 'aHR1RQ',
    description: 'Placeholder for the marks and numbers text input in the insurance edit form',
  },
});
